import { useEffect, useRef } from "react";

import { FeatureIslandMain } from "../main";
import { FeatureIslandCategorySideMenuForMain } from "./components";
import { FeatureIslandCategoryTabBarForMobile } from "./components/category-tab-bar";
import { FeatureIslandCategoryManagerContext } from "./context/category-manager";

import type { FeatureIslandCategoryManagerStoreType } from "./store";
import type { StoreApi } from "zustand";

type Props = {
	children: React.ReactNode;

	categoryManagerStore: StoreApi<FeatureIslandCategoryManagerStoreType>;
};

/**
 *
 * Features の UI で定義される Island デザインの main & category を定義するコンテナ。
 * category のデータは zustand を Provide する形で管理している為、Interface を継承した store を受け取る。
 *
 */
export const FeatureIslandMainWithCategory = ({ children, categoryManagerStore }: Props) => {
	const store = useRef(categoryManagerStore).current;

	useEffect(() => {
		return () => {
			// 先頭のカテゴリーをアクティブにする
			store.getState().setActiveCategoryID(store.getState().items[0].getState().categoryID);
		};
	}, [store]);

	return (
		<FeatureIslandCategoryManagerContext.Provider value={store}>
			<FeatureIslandMain
				rightSidebar={<FeatureIslandCategorySideMenuForMain />}
				mobileNavigation={<FeatureIslandCategoryTabBarForMobile />}
			>
				<div className="flex flex-col gap-y-14">{children}</div>
			</FeatureIslandMain>
		</FeatureIslandCategoryManagerContext.Provider>
	);
};

FeatureIslandMainWithCategory.displayName = "FeatureIslandMainWithCategory";
